import React from 'react';
import { useState, useEffect } from 'react';
import './customTittle.css';
import { Link, NavLink } from 'react-router-dom';

const CustomTittle = (props) => {
    let classNameButton = 'forAllTittle';

    if (props.size == 'medium') {
        classNameButton = 'forAllMediumTittle';
    }
    if (props.size == 'h4') {
        classNameButton = 'forAllH4Tittle';
    }
    if (props.size == 'small') classNameButton = 'forAllSmallTittle';

    return (
        <>
            <p className={classNameButton}>{props.children}</p>
        </>
    );
};

export default CustomTittle;
